export const STATUS = 'status';
export const REF_NUMBER = 'refnumber';
export const CHARGE_TOTAL = 'chargetotal';
export const SUCCESS = 'Success';
export const FAILURE = 'Failure';
export const AGENT_TRANSACTION_ID = 'agentTransactionId';
export const TRANSACTION_TYPE = 'PAYMENT';
